import { Component, inject } from '@angular/core';
import { FuelConsumptionTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FuelConsumptionTypeCreateDto,
  FuelConsumptionTypeDto,
  FuelConsumptionTypeExcelDownloadDto,
  FuelConsumptionTypeUpdateDto,
} from '../proxy/controlling/dtos/fuel-consumption-type';
import { FUELCONSUMPTIONTYPE_CONFIG, FUELCONSUMPTIONTYPE_FIELDS } from './fuel-consumption-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-fuel-consumption-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FuelConsumptionTypeService, ConfirmationService],
  templateUrl: './fuel-consumption-type.html',
  styleUrl: './fuel-consumption-type.scss',
})
export class FuelConsumptionType extends BaseCrudComponent<
  FuelConsumptionTypeDto,
  FuelConsumptionTypeCreateDto,
  FuelConsumptionTypeUpdateDto,
  FuelConsumptionTypeExcelDownloadDto
> {
  service = inject(FuelConsumptionTypeService);
  config = FUELCONSUMPTIONTYPE_CONFIG;
  fields = FUELCONSUMPTIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: FuelConsumptionTypeDto): FuelConsumptionTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isManualDataEntry: data.isManualDataEntry,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FuelConsumptionType';
  }
}
